export default {
  'language.usd': 'Dollaro',
  'language.eur': 'eura',
  'language.rub': 'strofinare',
  'language.rial': 'Rial',
  'language.german': 'Deutsche',
  'language.italian': 'Italiano',
  'language.arabic': 'عربی',
  'language.french': 'Français',
  'language.spanish': 'Español',
  'language.russian': 'русский',
  'language.english': 'English',
  'language.iran': 'فارسی',
  'language.yen': 'Yen',
  'language.japanese': 'Giapponese',
  'language.persian': 'Persiano',
  'component.select': 'Seleziona',
  'form.requierd': 'NECESSARIO',
  'form.isshort': 'Troppo Corto',
  'form.islong': 'Troppo Lungo',
  'form.invalid': 'Invalido',
  'form.number': 'Deve essere un numero ',
  'alert.info': 'Informazioni',
  'alert.warning': 'Avvertimento',
  'alert.error': 'Errore',
  'alert.notitle': ' ',
  'alert.success': 'Successo',
  'errorBoundary.oops': 'Oops!!',
  'errorBoundary.weSearched': 'La pagina desiderata non è stata trovata.',
  'error.receiveerror': 'Errore nella ricezione delle informazioni',
  NextStep: 'Passo Successivo',
  Previous: 'Precedente',
  FirstName: 'Nome',
  LastName: 'Cognome',
  BirthDate: 'Data di Nascita',
  NationalCode: 'Codice Nazionale',
  Yes: 'Si',
  No: 'No',
  Jalali: 'Jalali',
  Miladi: 'Miladi',
  Hijri: 'Hijri',
};
